import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import TopicsSection from './components/TopicsSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <MediaSection />
        <FaqSection />
        <TopicsSection />
        <CarouselSection />
        <AppSection />
        <CardsSection />
        <RankingSection />
        <UpdatesSection />
        <FeaturesSection />
        <IndexSection />
        <AboutSection />
        <ContactSection />
        <CommentsSection />
      </main>
      <Footer />
    </>
  );
}